import React from 'react';
import PropTypes from 'prop-types';
import { useConnect } from '@lore/query-connect';
import { PayloadStates } from '@lore/utils';
import { DialogManager } from '@/dialogs_new/DialogManager';
import useDialogLauncher from '@/dialogs-routable/_hooks/useDialogLauncher';
import { SolidButton } from '@/components/Button';
import GrayOutlineButton from '@/components/Button/OutlineButton.gray';
import ComposableEventHeader from '@/components_cards/ComposableEventHeader';
import DividerCard from '@/components/DividerCard';
import TagRow from '@/components_cards/tags/TagRow';
import EventTag from '@/components_cards/tags/EventTag';
import HiddenTag from '@/components_cards/tags/_resource/HiddenTag';
import Invitations from '@/pages/my-past/EventCreated/Invitations';

ActiveEvent.propTypes = {
  event: PropTypes.object.isRequired
};

export default function ActiveEvent(props) {
  const { event: theEvent } = props;
  const event = useConnect('event.byId', {
    id: theEvent?.data?.id
  }, { enabled: !!theEvent?.data?.id});

  const launch = useDialogLauncher();

  function onClickManage() {
    launch(DialogManager.EventManage.Config(event.id, `/manage`));
  }

  function onClickClose() {
    launch(DialogManager.EventClose.Config(event.id));
  }

  if (event.state !== PayloadStates.RESOLVED) return null;

  return (
    <DividerCard>
      <ComposableEventHeader
        event={event}
        tags={(
          <>
            <TagRow>
              <EventTag />
              <HiddenTag resource={event} />
              {/*more tags were here prior to 94b6a824 */}
            </TagRow>
            <Invitations event={event} />
          </>
        )}
        showTags={false}
        showCreator={false}
      />
      <div className="w-full bg-cs-gray-50 py-4 px-4 flex justify-between items-center flex-wrap gap-2">
        <div className="flex flex-wrap gap-2">
          {/* more buttons were here prior to 94b6a824 */}
        </div>
        <div className="flex flex-wrap gap-2">
          <GrayOutlineButton
            onClick={onClickClose}
            label="Close event"
          />
          <SolidButton
            onClick={onClickManage}
            label="Coordinate event"
          />
        </div>
      </div>
    </DividerCard>
  );
}
